import { ArrowDown, Check, CircleDot, LockKeyhole, ShieldCheck } from 'lucide-react';
import { PLATFORM_LAYERS } from '../../data/product';

export function ManagedAgentPlatformDiagram({ compact = false }: { compact?: boolean }) {
  return (
    <div className="bc-system-canvas" aria-labelledby="platform-diagram-title">
      <div className="sr-only" id="platform-diagram-title">
        Briefcase AI managed agent platform flow
      </div>
      <div className="bc-system-grid" aria-hidden="true" />
      <div className="relative z-10">
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-white/10 pb-6">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-white/45">Managed platform</p>
            <p className="mt-2 text-[20px] font-medium tracking-[-0.02em] text-white">One control layer for agent work</p>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full border border-emerald-300/25 bg-emerald-300/10 px-3 py-1.5 font-mono text-[11px] text-emerald-200">
            <CircleDot className="h-3 w-3" /> governed session
          </span>
        </div>

        <div className="mt-7 grid gap-3 md:grid-cols-4">
          {PLATFORM_LAYERS.map((layer, index) => (
            <div key={layer.label} className={`relative rounded-[10px] border border-white/12 bg-white/[0.055] p-4 ${compact ? 'min-h-[190px]' : ''}`}>
              {index < PLATFORM_LAYERS.length - 1 && (
                <ArrowDown className="absolute -bottom-5 left-1/2 z-20 hidden h-4 w-4 -translate-x-1/2 text-white/35 md:block" />
              )}
              <div className="flex items-center gap-2">
                {index === 0 ? <ShieldCheck className="h-4 w-4 text-indigo-200" /> : index === 2 ? <LockKeyhole className="h-4 w-4 text-amber-200" /> : <Check className="h-4 w-4 text-emerald-200" />}
                <p className="font-mono text-[11px] uppercase tracking-[0.12em] text-white/50">0{index + 1}</p>
              </div>
              <h3 className="mt-5 text-[17px] font-medium text-white">{layer.label}</h3>
              <p className="mt-2 text-[13px] leading-[1.55] text-white/60">{layer.summary}</p>
              {!compact && <ul className="mt-5 space-y-2 border-t border-white/10 pt-4">
                {layer.items.map((item) => <li key={item} className="flex items-start gap-2 text-[12px] text-white/72"><span className="mt-[5px] h-1 w-1 shrink-0 rounded-full bg-white/45" />{item}</li>)}
              </ul>}
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-5 text-[12px] text-white/50">
          <span>Business systems stay connected through scoped access.</span>
          <span>Every decision leaves evidence.</span>
        </div>
      </div>
    </div>
  );
}
